import { render, staticRenderFns } from "./SimpleLogoEditor.vue?vue&type=template&id=e167f500&"
import script from "./SimpleLogoEditor.vue?vue&type=script&lang=js&"
export * from "./SimpleLogoEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports